import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Option {
  value: string;
  label: string;
}

interface PlatformOptionsState {
  options: Option[];
  selectedPlatform: string;
}

const initialState: PlatformOptionsState = {
  options: [],
  selectedPlatform: "",
};

const platformOptionsSlice = createSlice({
  name: "platformOptions",
  initialState,
  reducers: {
    setPlatformOptions(state, action: PayloadAction<Option[]>) {
      state.options = action.payload;
    },
    setSelectedPlatform(state, action: PayloadAction<string>) {
      state.selectedPlatform = action.payload;
    },
    clearSelectedPlatform(state) {
      state.selectedPlatform = "";
    },
  },
});

export const {
  setPlatformOptions,
  setSelectedPlatform,
  clearSelectedPlatform,
} = platformOptionsSlice.actions;

export default platformOptionsSlice.reducer;
